"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const controlIsLegacy_1 = __importDefault(require("../../shared/controlIsLegacy"));
const getControlPathById = ({ controlId, rootControl, currentPath = [], }) => {
    if (controlId === rootControl.id) {
        return currentPath;
    }
    const controls = rootControl.controls || [];
    for (let index = 0; index < controls.length; index += 1) {
        const control = controls[index];
        if (!(0, controlIsLegacy_1.default)(control)) {
            throw new Error('Control is not legacy');
        }
        const controlPath = getControlPathById({
            controlId,
            rootControl: control,
            currentPath: [...currentPath, index],
        });
        if (controlPath) {
            return controlPath;
        }
    }
    return undefined;
};
exports.default = getControlPathById;
